import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as newProjectActions from '../Actions/newProjectActions';
import LangSelector from "../Components/Orders/LangSelector";
import { orderService } from "../Services/OrderService.js";
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import { Redirect } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

class SendTextContainer extends Component {
	constructor(props){
		super(props);
		
		const today = new Date();
		const defaultTitle = "text_"+today.getDate()+'-'+(today.getMonth()+1)+'-'+today.getFullYear()+'_'+today.getHours()+'-'+today.getMinutes()+".txt";
		
		//this.uploading=0;
		this.state = {
			selectedLanguages: {},
			uploading: 0,
			content: '',
			comment: '',
			title: defaultTitle,
		};
		
		this.handleChange = this.handleChange.bind(this);
		this.handlecheckboxUrgent = this.handlecheckboxUrgent.bind(this);
		this.updateLang = this.updateLang.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
	}
	
	componentDidMount() {

	}
	
	handleChange(e) {
		e.preventDefault();
		this.setState({[e.target.name]: e.target.value});
	}
	
	handlecheckboxUrgent(e){
		const {name, checked} = e.target;
		this.setState({[name]: (checked ? 1:0)});
	}
	
	updateLang(e){
		const {name, checked} = e.target;
		//console.log(name+","+checked);
		//this.setState(({selectedLanguages}) => ({ selectedLanguages.{name}: checked ] }))
		this.setState({
			selectedLanguages: {
				...this.state.selectedLanguages,
				[name]: checked
			}
		});
	}
	
	handleSubmit(e) {
//		console.log("handleSubmit:")
//		console.log(this.state)
		//this.uploading=1;
		this.setState({uploading: 1});
		const productKeys = Object.keys(this.state.selectedLanguages).filter( key => (this.state.selectedLanguages[key]));
		
		const parts = [ new Blob([this.state.content], {type: 'text/plain;charset=utf-8'}) ];
		let title = this.state.title.endsWith(".txt") ? this.state.title : this.state.title+".txt";
		
		const f = new File(parts, title, {type: "text/plain;charset=utf-8", lastModified: new Date()})
		const order = {
					id: 0,
					comment: this.state.comment,
					reference: "",
					doc: f,
					attachment: {},
					product: productKeys,
					urgent: this.state.urgent,
					special: false,
					quotation: false,
					enabled: true
				}
//		console.log(order);
		orderService.uploadProject(0, new Array(order), 0)
			.then(response1 => {	return orderService.runProjectWF(this.props.user.access_token, response1.data.id);})
			.then(response2 => { this.setState({uploading: 2});; return 1;})
			.catch(err => {/*console.log(err);*/});
	}
	
	render(){
		const { t } = this.props;
		
		if (this.state.uploading>0) {
			if (this.state.uploading>1) {
				return <Redirect to='/orderList'/>;
			}else{
				return <div className="content_centered">{t('sending')}....</div>;
			}
		}
		
		let lstProducts = this.props.user.customer.product.sort( (a, b) => a.langPair.code.localeCompare(b.langPair.code) );
		
		let lstLang = this.props.user.customer.product.filter(product => product.task === "translation")
														.sort( (a, b) => a.langPair.code.localeCompare(b.langPair.code) );
		let products = [];
		lstLang.forEach((product) => {
			products.push(<Grid item  xs={3}><FormControlLabel
					control={
						<Checkbox
							name={product.id}
							defaultChecked={false}
							value={product.id}
							color="primary"
							onChange={this.updateLang}
						/>
					}
					label={<Typography style={{fontFamily: "'Lato', sans-serif", fontSize: "14px"}}>{product.langPair.code}</Typography>}
					
				/></Grid>)
		});

		return (
			<div className="contentM">
			<form onSubmit={this.handleSubmit}>
				<Grid container direction="row" alignItems="flex-start" justify="flex-start" spacing={2} xs={12}>
					<Grid item xs={12}><h1 className="title">{t('Send_short_text')}</h1></Grid>
					<Grid item xs={12}>{t('languages')}:</Grid>
					<Grid container item direction="row" alignItems="flex-start" justify="flex-start" spacing={0} xs={6}>
						{products}
					</Grid>
					<Grid item xs={12}>
						<TextField
							id="title"
							label={t('title')}
							margin="normal"
							name="title"
							value={this.state.title}
							onChange={this.handleChange}
							style ={{width: '100%'}}
							InputLabelProps={{
								shrink: true,
							}}
						/>
					</Grid>
					<Grid item xs={12}>{t('coments')}:</Grid>
					<Grid item xs={12}>
						<textarea
								onChange={this.handleChange}
								style={{width: "100%"}}
								rows="1"
								id="comment"
								name="comment"
								value={this.state.comment}
							/>
					</Grid>
					<Grid item xs={12}>{t('text_content')}:</Grid>
					<Grid item xs={12}>
						<textarea
								onChange={this.handleChange}
								style={{width: "100%"}}
								rows="4"
								id="content"
								name="content"
								value={this.state.content}
							/>
					</Grid>
					<Grid item  xs={3}>
						<FormControlLabel
							control={
								<Checkbox
									name="urgent"
									checked={this.state.urgent>0}
									color="primary"
									onChange={this.handlecheckboxUrgent}
								/>
							}
							label={<Typography style={{fontFamily: "'Lato', sans-serif", fontSize: "14px"}}>{t('urgent')}: </Typography>}
							
						/>
					</Grid>
					<Grid item xs={6}>
						<Button style={{fontFamily: "'Lato', sans-serif", fontSize: "18px", backgroundColor: "#dfdfdf"}} onClick={this.handleSubmit} color="primary">
							{t('send')}
						</Button>
					</Grid>
				</Grid>
			</form>
			</div>
			);
	}
}

function mapStateToProps(state, ownProps) {
	return {user: state.user}
}

function mapDispatchToProps(dispatch) {  
	return {actions: bindActionCreators(newProjectActions, dispatch)}
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation() (SendTextContainer));